export default __webpack_public_path__ + "static/media/postgresql-negative.b9fd2364.svg";